<template>
  <b-card-code
    title="Ajouter une délégation logistique"
    aria-label="Formulaire d’ajout de délégation logistique"
    role="form"
  >
    <b-card-text>
      <span id="delegation-form-desc">Ajoutez une délégation. Les champs * sont obligatoires.</span>
    </b-card-text>
    <validation-observer ref="simpleRules">
      <b-form aria-labelledby="delegation-form-desc">
        <b-row>
          <b-col md="12">
            <b-form-group
              label="Nom de la délégation *"
              label-for="delegation-name"
            >
              <validation-provider
                #default="{ errors }"
                name="Nom de la délégation"
                rules="required"
              >
                <b-form-input
                  id="delegation-name"
                  v-model="delegation.name"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Nom officiel de la délégation"
                  aria-required="true"
                />
                <small
                  id="delegation-name-help"
                  class="form-text text-muted d-none"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="Gouvernorat *"
              label-for="delegation-gov"
            >
              <validation-provider
                #default="{ errors }"
                name="Gouvernorat"
                rules="required"
              >
                <v-select
                  id="delegation-gov"
                  v-model="delegation.governorate"
                  :clearable="false"
                  placeholder="Choisir un gouvernorat"
                  label="name"
                  :options="governorates"
                  aria-required="true"
                />
                <small
                  id="delegation-gov-help"
                  class="form-text text-muted d-none"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-button
              variant="primary"
              type="submit"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1"
              :class="{ 'disabled-cursor': isLoading || !isDelegationValid }"
              :disabled="isLoading || !isDelegationValid"
              aria-label="Ajouter la délégation logistique"
              @click.prevent="addDelegation"
            >
              Ajouter
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card-code>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'

import {
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BCardText,
} from 'bootstrap-vue'
import axios from 'axios'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BCardText,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      delegation: {
        name: '',
        governorate: '',
      },
      governorates: [],
      isLoading: false,
    }
  },
  computed: {
    isDelegationValid() {
      return (
        this.delegation.name !== ''
        && this.delegation.governorate.id !== ''
      )
    },
  },
  created() {
    this.getGovernorates()
  },
  methods: {
    async getGovernorates() {
      try {
        this.isLoading = true
        const { data } = await axios.get('/api/governorates/')
        this.governorates = data
        this.isLoading = false
      } catch (error) {
        this.showToast('danger', 'top-center', 'Network error: ')
      }
    },
    async addDelegation() {
      const success = await this.$refs.simpleRules.validate()
      if (success) {
        try {
          this.isLoading = true
          await axios.post('/api/delegations/create/', {
            name: this.delegation.name,
            governorate: this.delegation.governorate.id,
          })
          this.isLoading = false
          setTimeout(() => {
            this.showToast('success', 'top-center', 'Delegation ajouté avec succés')
          }, 1000)
          this.$router.push('/delegations/')
        } catch (error) {
          setTimeout(() => {
            this.showToast('danger', 'top-center', error.toString())
          }, 1000)
        }
      } else {
        setTimeout(() => {
          this.showToast('danger', 'top-center', 'champ obligatoire ! vérifier votre donnée !')
        }, 1000)
      }
    },
    showToast(variant, position, text) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Notification',
            icon: 'InfoIcon',
            text,
            variant,
          },
        },
        {
          position,
        },
      )
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
